var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m21.077 8.205h-2.615c-.924 0-1.116.378-1.116 1.333v2.308h3.731l-.359 4.052h-3.372v12.102h-4.833v-12.051h-2.513v-4.103h2.513v-3.23c0-3.034 1.622-4.616 5.218-4.616h3.346z","fill":"#fff","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"height":"32","viewBox":"0 0 32 32","width":"32"};

module.exports = Facebook;

Facebook.default = Facebook;
